export default "__VITE_ASSET__DX5mAUel__"